// Prayer content — organized by category. Each prayer has an optional scripture reference,
// the scripture text (optional), and the prayer body itself. Line breaks preserved.

export const PRAYER_CATEGORIES = [
  {
    id: "daily",
    label: "Daily Prayers",
    tagline: "Bring your day to God — one moment at a time.",
    prayers: [
      {
        heading: "Morning Prayer",
        reference: "Psalm 5:3 · NLT",
        scripture:
          "Listen to my voice in the morning, Lord. Each morning I bring my requests to you and wait expectantly.",
        body:
          "Father, in the name of Jesus, I thank you that my voice is heard by you each morning. I thank you that as I bring my requests to you they are met with your loving kindness.",
      },
      {
        heading: "Commitment of Plans",
        reference: "Proverbs 16:3",
        scripture:
          "Commit your works to the LORD and your plans will be established.",
        body:
          "Father, I commit all my plans to you today. Be the driver of my life, guide me, lead me, keep me, and bless me abundantly.",
      },
      {
        heading: "Obedience to God's Word",
        reference: "II Chronicles 27:6 · NLT",
        scripture:
          "King Jotham became powerful because he was careful to live in obedience to the Lord his God.",
        body:
          "Father, in the name of Jesus, help me to live in perfect obedience to your word. Help me to live a life that is holy and pleasing in your sight.",
      },
      {
        heading: "Seeking God for Prosperity",
        reference: "II Chronicles 26:5 · KJV",
        scripture:
          "And he sought God in the days of Zechariah, who had understanding in the visions of God: and as long as he sought the LORD, God made him to prosper.",
        body:
          "Father, in the name of Jesus, help me to seek You all my days, and never forget your goodness. It is through seeking you that you will make me prosper for Your name's sake.",
      },
      {
        heading: "Wholehearted Seeking of God",
        reference: "II Chronicles 31:21 · NLT",
        scripture:
          "In all that he did in the service of the Temple of God and in his efforts to follow God's laws and commands, Hezekiah sought his God wholeheartedly. As a result, he was very successful.",
        body:
          "Father, help me to seek you wholeheartedly. I know that you hear me and as I continue to live right, you will make me very successful.",
      },
    ],
  },
  {
    id: "kingdom",
    label: "Kingdom Seeking",
    tagline: "Prayers to walk in step with the Father's heart.",
    prayers: [
      {
        heading: "Perfect Harmony with the Father",
        reference: "John 5:19–20 · NLT",
        scripture:
          "So Jesus explained, 'I tell you the truth, the Son can do nothing by himself. He does only what he sees the Father doing… For the Father loves the Son and shows him everything he is doing.'",
        body:
          "Father, in the name of Jesus, I can do nothing of myself. Please show me what you are doing so I can do the same things. I thank you that because you love me, you are showing me everything you are doing so I can be in perfect harmony with you in order to do greater works so that men can be astonished.",
      },
      {
        heading: "Show Me the Way",
        reference: "Proverbs 3:5–6 · NLT",
        scripture:
          "Trust in the Lord with all your heart; do not depend on your own understanding. Seek his will in all you do, and he will show you which path to take.",
        body:
          "Holy Spirit, show me the way — for you are the only one who knows the way.\n\nWhat am I doing I should not be doing?\nWhat am I not doing I should be doing?\nWhat am I currently doing I could be doing better?",
      },
      {
        heading: "Eyes That See Clearly",
        reference: "Numbers 24:15–16 · NLT",
        scripture:
          "This is the message of Balaam son of Beor, the message of the man whose eyes see clearly, the message of one who hears the words of God, who has knowledge from the Most High, who sees a vision from the Almighty, who bows down with eyes wide open.",
        body:
          "Father, in the name of Jesus, I thank you that my natural and spiritual eyes see clearly. I thank you for giving me the ability to hear the written word of God and the spoken word of God. I thank you that I have knowledge from the Most High, see visions of the Almighty, and have a heart to bow to you with eyes wide open.",
      },
      {
        heading: "Spiritual Wisdom and Insight",
        reference: "Ephesians 1:17–19",
        body:
          "Father, in the name of Jesus, give me spiritual wisdom and insight so that I may grow in the knowledge of God. I pray that my heart will be flooded with light so that I can understand the confident hope you have given me. I also pray that I will understand the incredible greatness of your power.",
      },
      {
        heading: "Rooted and Grounded in Love",
        reference: "Ephesians 3:16–19 · NLT",
        scripture:
          "I pray that from his glorious, unlimited resources he will empower you with inner strength through his Spirit. Then Christ will make his home in your hearts as you trust in him. Your roots will grow down into God's love and keep you strong…",
        body:
          "I pray that I would be strengthened with power by your Spirit in the inner man; that Christ may dwell in my heart by faith; that being rooted and grounded in love, I may be able to comprehend its breadth, length, depth, and height; and to know the love of Christ which is beyond natural knowledge and that I might be filled with all the fullness of God.",
      },
      {
        heading: "Complete Knowledge of His Will",
        reference: "Colossians 1:9–11",
        scripture:
          "We ask God to give you complete knowledge of his will and to give you spiritual wisdom and understanding. Then the way you live will always honor and please the Lord, and your lives will produce every kind of good fruit.",
        body:
          "Father, I ask that you would give me complete knowledge of your will for my life, then the way I live will always honor and please you and my life will produce every kind of good fruit. All the while, I will grow as I learn to know you better and better. I also pray that I will be strengthened with all your glorious power so I will have all the endurance and patience I need.",
      },
      {
        heading: "Remarkable Secrets",
        reference: "Jeremiah 33:3 · NLT",
        scripture:
          "Ask me and I will tell you remarkable secrets you do not know about things to come.",
        body:
          "Father, according to Jeremiah 33:3, I ask you to show me great and mighty things fenced in and hidden from plain view. Show me remarkable secrets about things to come.",
      },
      {
        heading: "Boldness to Preach",
        reference: "Acts 4:29–30",
        scripture:
          "And now, O Lord, hear their threats, and give us, your servants, great boldness in preaching your word. Stretch out your hand with healing power; may miraculous signs and wonders be done through the name of your holy servant Jesus.",
        body:
          "Father, in the name of Jesus, give me great boldness in preaching your word. Stretch out your hand with healing power; may miraculous signs and wonders be done through the name of your holy servant Jesus.",
      },
      {
        heading: "Producing Much Fruit",
        reference: "John 15:8 · John 17:4 · NLT",
        scripture:
          "When you produce much fruit, you are my true disciples. This brings great glory to my Father. I brought glory to you here on earth by completing the work you gave me to do.",
        body:
          "Father, in the name of Jesus, help me to produce much fruit as a disciple of Christ and help me to accomplish the assignments you have given me to do so that you can receive much glory.",
      },
    ],
  },
  {
    id: "warfare",
    label: "Spiritual Warfare",
    tagline: "Stand strong. Decree the finished work of Christ.",
    prayers: [
      {
        heading: "No Weapon Shall Prosper",
        reference: "Isaiah 54:17",
        scripture:
          "No weapon formed against you shall prosper, and every tongue which rises against you in judgment you shall condemn. This is the heritage of the servants of the Lord.",
        body:
          "I decree and declare that every weapon of sickness, poverty, or delay forged against me is destroyed.\n\nI silence every accusing tongue rising against my life in Jesus' name.\n\nNo demonic weapon, curse, or evil plot formed against me will ever succeed.\n\nMy heritage in Christ is absolute divine protection.",
      },
      {
        heading: "Overcome by the Blood",
        reference: "Revelation 12:11",
        scripture:
          "And they overcame him by the blood of the Lamb and by the word of their testimony, and they did not love their lives to the death.",
        body:
          "Father, I plead the blood of Jesus over my life, my home, and my calling. Let the speaking blood of the Lamb answer every demonic accusation against me.\n\nI am victorious by the blood of Jesus.\n\nMy testimony is a weapon that destroys the works of the enemy.",
      },
      {
        heading: "Divine Authority",
        reference: "Luke 10:19",
        scripture:
          "Behold, I give you the authority to trample on serpents and scorpions, and over all the power of the enemy, and nothing shall by any means hurt you.",
        body:
          "Lord, I exercise my God-given authority today.\n\nI crush every demonic serpent and scorpion assigned to my path, and I declare my total immunity from their poison.\n\nI walk in delegated, divine authority — I tread over demonic forces, and absolutely nothing has the power to harm me.",
      },
      {
        heading: "More Than a Conqueror",
        reference: "Romans 8:37",
        scripture: "Yet in all these things we are more than conquerors through Him who loved us.",
        body:
          "Father, let the reality of my identity as a conqueror manifest in every area of my life.\n\nI receive the grace to walk in unending victory.\n\nI am not just a survivor — I am more than a conqueror.\n\nThrough the love of Christ, every battle ends in my favor.",
      },
      {
        heading: "Scattered Seven Ways",
        reference: "Deuteronomy 28:7",
        scripture:
          "The Lord will cause your enemies who rise against you to be defeated before your face: they shall come out against you one way and flee before you seven ways.",
        body:
          "God is my defender. When the enemy attacks me from one direction, the power of God scatters them in seven different directions.",
      },
      {
        heading: "A Defeated Foe",
        reference: "Colossians 2:15",
        scripture:
          "Having disarmed principalities and powers, He made a public spectacle of them, triumphing over them in it.",
        body:
          "Lord Jesus, thank You for stripping the enemy of his power at the cross.\n\nI enforce Your victory today over every principality trying to operate in my territory.\n\nSatan and his cohorts have been completely disarmed by Jesus. I am fighting a defeated foe, and I share in Christ's ultimate triumph.",
      },
    ],
  },
];
